module.exports = __webpack_public_path__ + "img/logo-core-sm.ca9c46f6.png";